export const CONTENT_PAGES_ROUTES = {
  pagesList: '/pages',
  pageCreation: '/pages/new',
  pageEditing: '/pages/:id',
} as const;
